<template>
	<div class="header-container">
		<!-- 头部背景图 -->
		<div class="header-bg row-center">
			<img src="../../assets/home/top_bg.png" alt="" />
		</div>
		<div class="header-content row-center wrap">
			<div class="header-inner">
				<!-- 顶部标题 -->
				<div class="header-title flex-center">
					<!-- <div class="logo col-center" v-if="type.logo">
						<img :src="type.logo" alt="" />
					</div> -->
					<div class="title">
						{{type.title}}
					</div>
					<div class="title-col">{{type.title}}</div>
				</div>
				<slot></slot>
			</div>
			<div class="page-bottom flex-center">
				<!-- Copyright © 2024 教育部高等学校实验室建设与实验教学指导委员会 版权所有 -->
				沪ICP备2021028823号 | 版权所有 © 2024 {{type.copyright}} | 联系我们:19524511118(微信)，15045096087(微信)
			</div>
		</div>
	</div>
</template>

<script>
	import {
		type
	} from '../../common/config.js'
	export default {
		name: 'cus-header',
		props: {

		},
		components: {},
		data() {
			return {
				type
			}
		},
		created() {},
		mounted() {

		},
		methods: {

		}

	}
</script>

<style lang="scss" scoped>
	.header-container {
		position: relative;

		.header-bg {
			position: absolute;
			width: 100%;
			top: 0;
			z-index: 0;

			img {
				min-width: 1000px;
				width: 100%;
			}
		}

		.header-content {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;

			.header-inner {
				width: 100%;
				max-width: 1320px;

				.header-title {
					padding: 3.125rem 0;

					.title-col {
						display: none;
					}

					.logo {
						width: 4.5rem;
						height: 4.5rem;
						flex-shrink: 0;
						margin-right: 10px;
					}

					.title {
						// height: 4rem;
						// margin-left: .5rem;
						// padding-top: .5rem;
						// box-sizing: border-box;
						font-weight: 800;
						font-size: 48px;
						color: #FFFFFF;
						text-shadow: 0px 2px 10px rgba(131,157,190,0.35);
					}

					img {
						width: 100%;
					}
				}
			}

			.page-bottom {
				width: 100%;
				color: #949BB0;
				padding: 5rem;
			}
		}

		.floor {
			// padding: 5.625rem 0;
			// text-align: center;
			// color: #949BB0;
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 922px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {
		.header-container {
			.header-bg {
				width: 100%;
				overflow: hidden;
			}

			.header-content {
				.header-inner {
					.header-title {
						justify-content: center;
						padding: 1.875rem 0;
						padding-left: 1rem;

						.title {
							width: 45rem;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 767px) {


		.header-container {
			.header-bg {
				width: 100%;
				overflow: hidden;
			}

			// overflow: hidden;
			.header-content {
				.header-inner {
					max-width: 100%;

					.header-title {
						padding: 1.25rem;

						.logo {
							width: 3rem;
							height: 3rem;
							flex-shrink: 0;
						}

						.title {
							display: none;
						}

						.title-col {
							color: white;
							padding-left: 1.25rem;
							font-size: 1.25rem;
							display: block;
							font-weight: bold;
						}
					}
				}

				.page-bottom {
					padding: 1.875rem;
				}
			}
		}


	}
</style>